import ProjectPresetsParentFieldControlComponent from './parent-field-control.component'

export default ProjectPresetsParentFieldControlComponent
